import { Link } from '@tanstack/react-router';

import { MascotWave } from '../components/brand.tsx';
import { Badge, PageHeader } from '../components/ui.tsx';
import { useLang } from '../i18n.ts';
import type { NavItem } from '../layout/nav.ts';

/** Screens planned for the next parts of M6: honest "being built" page, never a fake screen. */
export function PlaceholderPage({ label }: { readonly label: NavItem['label'] }) {
  const { t } = useLang();
  return (
    <>
      <PageHeader
        title={t(`nav.${label}`)}
        actions={<Badge tone="warning">{t('common.comingSoon')}</Badge>}
      />
      <div className="flex flex-col items-center gap-4 rounded-xl border border-border bg-surface p-10 text-center">
        <MascotWave className="w-40" />
        <h2 className="text-lg font-bold">{t('placeholder.title')}</h2>
        <p className="max-w-md text-sm text-muted">{t('placeholder.body')}</p>
      </div>
    </>
  );
}

export function NotFoundPage() {
  const { t } = useLang();
  return (
    <div className="flex flex-col items-center gap-4 p-10 text-center">
      <MascotWave className="w-40" />
      <h1 className="text-xl font-bold">{t('notFound.title')}</h1>
      <Link to="/" className="font-semibold text-link hover:underline">
        {t('notFound.home')}
      </Link>
    </div>
  );
}
